/*
---
covers:
  - frontend/src/pages/empresa/identidad/registro.tsx
  - frontend/src/pages/empresa/identidad/mi-informacion.tsx
  - frontend/src/pages/empresa/identidad/mi-ficha.tsx
  - frontend/src/components/ficha-facts.tsx
  - frontend/src/hooks/empresa/identidad/use-ficha.ts
  - backend/app/empresa/identidad/routers/registro.py
revisado: 2026-09-28
---
*/
import type {ManualSeccion} from '../types'

export const seccion: ManualSeccion = {
  id: 'tu-registro',
  titulo: 'Tu registro',
  resumen:
    'Cómo te unes a tu empresa en Kairos con el link de registro que te compartió: tu cédula, tus datos y una contraseña — el correo es opcional.',
  enCorto: ['Unirse a su empresa con el enlace', 'Ponga cédula, datos y una contraseña', 'El correo es opcional'],
  replayId: 'tu-registro',
  operaciones: [
    {
      id: 'ingresar-cedula',
      titulo: 'Abrir el link de tu empresa e ingresar tu cédula',
      como: 'Tu empresa te comparte un link de registro (uno por empresa). Al abrirlo ves el nombre de tu empresa y un único campo, «Cédula de ciudadanía (CC)»; el botón «Continuar» sondea si esa cédula ya tiene cuenta en Kairos.',
      porQueImporta:
        'Kairos identifica a las personas por cédula, no por correo — es el mismo documento con el que luego inicias sesión, así que Kairos sabe de una vez si debe pedirte una contraseña nueva o solo confirmar la existente.',
    },
    {
      id: 'crear-cuenta-nueva',
      titulo: 'Crear tu cuenta si es tu primera vez',
      como: 'Si tu cédula es nueva en Kairos, el formulario te pide nombre, apellido, correo y teléfono (los dos opcionales) y una contraseña de mínimo 8 caracteres con al menos un carácter especial; el botón «Crear mi cuenta y vincularme» te vincula a tu empresa y te deja con sesión iniciada.',
      porQueImporta:
        'El correo es opcional porque muchos trabajadores no tienen uno — tu acceso a Kairos nunca depende de tenerlo; si lo dejas, Kairos te envía un enlace para confirmarlo, pero no es obligatorio para operar.',
    },
    {
      id: 'cuenta-que-ya-existe',
      titulo: 'Si tu empresa ya te había creado la cuenta',
      como: 'Si la cédula ya tiene cuenta en Kairos, el registro por link no te pide datos otra vez: te pide tu contraseña para vincularte. Y si nunca has entrado —tu empresa te creó la cuenta pero todavía no la has reclamado—, el registro te responde que esa cédula ya tiene cuenta: la abres con el enlace de invitación que te llegó, o le pides a la persona encargada en tu empresa que te lo reenvíe desde «Invitar a la plataforma».',
      porQueImporta:
        'Es lo que impide que alguien más, sabiéndose tu cédula, le ponga contraseña a tu cuenta desde el link público —que circula por WhatsApp o como código QR entre todos tus compañeros— y entre como si fuera tú. La contraseña de una cuenta que ya existe solo se define por el enlace de invitación, que llega a tus manos y a las de nadie más.',
    },
    {
      id: 'completar-ficha-despues-registro',
      titulo: 'Seguir de corrido hasta el final: ficha, preguntas de riesgos y ficha sociodemográfica',
      como: 'Apenas resuelves tu identidad, Kairos te lleva a tu ficha y el asistente sigue solo: las páginas de campos, las preguntas de riesgos y, al terminarlas, tu ficha sociodemográfica-laboral. No hay un botón para dejarlo para después. Si sales a la mitad, abre otra vez el MISMO link de tu empresa: te pide tu contraseña y te devuelve al punto donde ibas.',
      porQueImporta:
        'La Resolución 0312/2019 exige este cuestionario, y llenarlo de corrido es lo que evita volver a buscarlo. Ningún campo es obligatorio: lo que cierra tu registro es aceptar el tratamiento de datos y sellar al final.',
    },
  ],
}
